import React,{useState} from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions} from "@material-ui/core";
import {Input, Button} from "@material-ui/core";

const EMPTY_FUNC = () => {};
const DialogContext = React.createContext([
	EMPTY_FUNC,
	EMPTY_FUNC
]);
export const useDialog = () => React.useContext(DialogContext);

function DialogContainer(props) {
	const { content, Content, title, actions, open, onClose, onKill, width, disableBackdropClick } = props;
	const [data, setData] = useState();
	const close = (a, reason) => {
		if(!disableBackdropClick){
			return onClose();
		}
	};
	return (
		<Dialog fullWidth={true}	maxWidth={width} open={open} onClose={close} onExited={onKill}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				{content==="input" && <Input onChange={e=>setData(e.target.value)} />}
				<Content {...props} />
				
			</DialogContent>
			<DialogActions>
				{(actions || []).map(a=><Button onClick={()=>(a.onClick(data),onClose())}>{a.label}</Button>)}
			</DialogActions>
		</Dialog>
	);
}

export default function DialogProvider({ children }) {
	const [dialogs, setDialogs] = React.useState([]);
	const createDialog = (option) => {
		const dialog = { ...option, open: true };
		setDialogs((dialogs) => [...dialogs, dialog]);
	};
	const closeDialog = (...data) => {
		console.log({data})
		setDialogs((dialogs) => {
			const latestDialog = dialogs.pop();
			if (!latestDialog) return dialogs;
			if (latestDialog.onClose) latestDialog.onClose(...data);
			return [...dialogs].concat({ ...latestDialog, open: false });
		});
	};
	const contextValue = React.useRef([createDialog, closeDialog]);

	return (
		<DialogContext.Provider value={contextValue.current}>
			{children}
			{dialogs.map((dialog, i) => {
				const { onClose, ...dialogParams } = dialog;
				const handleKill = () => {
					if (dialog.onExited) dialog.onExited();
					setDialogs((dialogs) => dialogs.slice(0, dialogs.length - 1));
				};

				return (
					<DialogContainer
						key={i}
						onClose={closeDialog}
						onKill={handleKill}
						{...dialogParams}
					/>
				);
			})}
		</DialogContext.Provider>
	);
}
